import { gql } from '@apollo/client';

export default gql`
  query User {
    user {
      emailAddress
      firstName
      lastName
    }
  }
`;
